import React from 'react';
import { Button } from "antd";

const AltButton = ({ className, style, children, htmlType, loading, onClick }) => {
  return (
    <Button
      htmlType={htmlType}
      loading={loading}
      className={`${className} px-12 py-4 text-white hover:text-green-200 text-[16px] font-semibold flex items-center justify-center border-0 rounded-3xl`}
      style={{
        background:"#976A3E",
        minHeight: "38px",
        minWidth: "100px",
        ...style,
      }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

export default AltButton;
